import { ROUTE_NAME } from '@/lib/constant';

export default [
    {
        path: '/rank/platform',
        name: ROUTE_NAME.RANK_PLATFORM,
        meta: {
            title: '全平台排行',
            scrollBehavior: 'top',
        },
        component: () => import(/* webpackChunkName: "rank" */ '@/pages/rank/platform.vue'),
    },
    {
        path: '/rank_c/:activityId?',
        name: ROUTE_NAME.RANK_C,
        meta: {
            title: '百日排行',
            scrollBehavior: 'top',
        },
        component: () => import(/* webpackChunkName: "rank" */ '@/pages/activity/rank_c.vue'),
    },
    {
        path: '/rank_o/:activityId?',
        name: ROUTE_NAME.RANK_O,
        meta: {
            title: '百日排行',
            scrollBehavior: 'top',
        },
        component: () => import(/* webpackChunkName: "rank" */ '@/pages/activity/rank.vue'),
    },
    {
        path: '/rank/:activityId?',
        name: ROUTE_NAME.RANK,
        meta: {
            title: '百日排行',
            scrollBehavior: 'top',
        },
        // component: () => import(/* webpackChunkName: "rank" */ '@/pages/activity/rank.vue'),
        component: () => import(/* webpackChunkName: "rank" */ '@/pages/activity/rank_temp.vue'),
    },
    {
        path: '/rank_share/:activityId?',
        name: ROUTE_NAME.RANK_SHARE,
        meta: {
            title: '百日排行',
            scrollBehavior: 'top',
        },
        component: () => import(/* webpackChunkName: "rank" */ '@/pages/activity/rank_temp_share.vue'),
    },
    {
        path: '/rank_team_24/:activityId?',
        name: ROUTE_NAME.RANK_TEAM_24,
        meta: {
            title: '百日排行',
            scrollBehavior: 'top',
        },
        component: () => import(/* webpackChunkName: "rank" */ '@/pages/activity/rank_team_24.vue'),
    },
];
